// Factory: Returns function used as callback in trackerDoc document listener
function imageStats(store, doc) {
    return function (doc) {
        var {
            numSubmitted,
            numPending,
            maxNumPending,
            numSelected,
            numPublished,
            numRejected,
        } = doc.data();

        var imageCounts = {
            numSubmitted,
            numPending,
            maxNumPending,
            numSelected,
            numPublished,
            numRejected,
        };
        // console.log('---->>>>>>>> imageStats listener function ran', doc.data());
        // console.log('pending images:', doc.data().pending)
        store.dispatch('uploadTracker/setImageCounts', imageCounts)
        store.dispatch('uploadTracker/setImageNamesAll', doc.data().imageNamesAll);
        // store.dispatch('uploadTracker/setImagesList', {
        //     imageType: 'Pending',
        //     images: doc.data().pending
        // });
        var imageTypes = ['Pending', 'Selected', 'Published', 'Rejected', 'Submitted'];
        imageTypes.forEach(typeName => {
            store.dispatch('uploadTracker/setImagesList', {
                imageType: typeName,
                images: doc.data()[typeName.toLowerCase()]
            });
        })

        store.dispatch('incNumUploadTrackerChanges');
        // console.log('numTrackerChanges', store.state.numUploadTrackerChanges);

        // For new upload, number of tracker doc updates is 2 ... if we're there, signal that all ops for the upload have completed ...
        if (store.state.numUploadTrackerChanges === 2) {
            store.dispatch('setUploadInProgress', false);
        }

    };
}

console.log(8885);

function pollTrackerDocExists(
    uid,
    fapi,
    initialDelayMs = 1000,
    attemptIntervalMs = 1000,
    maxNumAttempts = 5
) {
    async function doesDocExist(trackerObj) {
        trackerObj.count++;
        // console.log('# TRIES:', trackerObj.count);

        // docExists returns the doc if it exists (truthy); otherwise returns boolean false
        var doc = await fapi.docExists('uploadTrackers', uid);
        if (doc) {
            trackerObj.res(doc); // Resolve the promise with the doc to it's available at the call site 
        } else {
            if (trackerObj.count < maxNumAttempts) {
                setTimeout(doesDocExist, attemptIntervalMs, trackerObj);
            } else {
                console.error('Establish tracker doc listener: Failed - timed out.')
                trackerObj.res(false);
            }
        }
    }
    return new Promise((res, rej) => {
        var attemptsTracker = {
            count: 0,
            result: false,
            res
        };
        setTimeout(doesDocExist, initialDelayMs, attemptsTracker);
    });
}


// NOTE: To do: clearState -- call this on logout
var stateUtil = {
    initState: async function (store, fapi) {
        var uid = fapi.user.uid;


        await this.setBreeds(fapi, store);

        // Create and store appStatus document listener 
        this.setAppStatusListener(fapi, store);

        // Create and store user profile and user document listener
        var userDoc = await fapi.getDocById('users', uid);
        if (userDoc.exists) {
            store.dispatch('setUserProfile', userDoc.data());
            this.setUserDocListener(userDoc.ref, store, userDoc);
        }

        // Set layout state 
        store.dispatch(
            'layout/setShowWelcomeBar',
            userDoc.data().showWelcomeBar
        );
        store.dispatch(
            'layout/setNaveBarSticky',
            userDoc.data().navBarSticky
        );

        // Create and store uploadTracker document listener
        var trackerDocRef = fapi.getDocRefById('uploadTrackers', uid);
        var trackerDoc = await trackerDocRef.get();
        if (trackerDoc.exists) {
            // console.log('HELPER file - uploadTracker doc:', trackerDoc.data())
            this.setTrackerDocListener(store, trackerDocRef, trackerDoc)
            return true;
        }

        // Tracker doc does not exist, e.g. occurs right after new account signup, since created in Firebase cloud 
        // function on creation of new user, it takes a few seconds for the uploadTracker doc to get created.
        trackerDoc = await pollTrackerDocExists(uid, fapi, 2000, 2000, 5);
        if (trackerDoc) {
            this.setTrackerDocListener(store, trackerDocRef, trackerDoc)
            return true;
        }

        return false; // ???  ... put above in try/catch ??? think of outcome, what it means to user if error (where error?), how 
        // to report to user - if at all - etc.
    },

    setBreeds: async function (fapi, store) {
        try {
            var breedsDocRef = fapi.db.collection('breeds').doc('master');
            var breedsDoc = await breedsDocRef.get();
            if (breedsDoc.exists) {
                store.dispatch('setBreeds', breedsDoc.data().all);
            } else {
                throw new Error('Breeds list document does not exist in the database.')
            }
        } catch (err) {
            console.error('Error getting breeds list:', err.message);
        }

    },

    setAppStatusListener: async function (fapi, store) {
        var appStatusDocRef = fapi.getDocRefById('appStatus', 'client');
        var appStatusDoc = await appStatusDocRef.get();
        var appStatusDocListener = appStatusDocRef.onSnapshot(function (appStatusDoc) {
            store.dispatch('setAppActive', appStatusDoc.data().appActive);
            store.dispatch('setUploadSvcActive', appStatusDoc.data().uploadSvcActive);
            store.dispatch('setContactActive', appStatusDoc.data().contactActive);
        })
        store.dispatch('setDocListener', {
            appStatus: appStatusDocListener,
        });
    },

    // Set listener on user doc to update user 'enabled' property.
    setUserDocListener: function (userDocRef, store, userDoc) {
        var userDocListener = userDocRef.onSnapshot(function (userDoc) {
            store.dispatch('setUserEnabled', userDoc.data().enabled)
        });
        store.dispatch('setDocListener', {
            userDoc: userDocListener,
        });
    },

    setTrackerDocListener: function (store, trackerDocRef, trackerDoc) {
        var trackerDocListenerCb = imageStats(store, trackerDocRef, trackerDoc);
        console.log('the listener callback:', trackerDocListenerCb)
        var trackerDocListener = trackerDocRef.onSnapshot(trackerDocListenerCb);
        store.dispatch('setDocListener', {
            imageCounts: trackerDocListener,
        });
    },

    clearState: async function (store, fapi) {

    }
}

export default stateUtil;